import { Blog } from "../../../models/Blog";
import { CommentModel } from "../../../models/Comment";

abstract class IBlogRepository {
    abstract getBlogs: (categories: string[]) => Promise<Blog[]>;
    abstract getCategories: () => Promise<string[]>;
    abstract getBlog: (id: string) => Promise<Blog>;
    abstract addComment: (blogId: string, comment: CommentModel) => Promise<CommentModel>;
    abstract deleteComment: (commentID: string) => Promise<boolean>;
}

export default IBlogRepository;
